<template>
  <div id="app">
    <!--<router-view/>-->
    <router-view v-if="show" ></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
  	return {
  		show: false
  	}
  },
  created () {
  	// 调用首页数据接口，获取最新数据的时间，并赋给全局
  	this.$fun.getNewDate('').then(res => {
  		if (res.code === '200') {
			  this.$store.dispatch('getNewInfoTime', res.data)
			  this.show = true
			}
  	})
  }
}
</script>

<style>
#app {
}
</style>



// WEBPACK FOOTER //
// src/App.vue